// ported from src/web/style/_breakpoints.scss

export const BREAKPOINT_MOBILE = '48em';
export const BREAKPOINT_MEDIUM = '64em';
export const BREAKPOINT_DESKTOP = '1170px';
export const BREAKPOINT_TOP_BAR_MOBILE = BREAKPOINT_MOBILE;
export const BREAKPOINT_TOP_BAR_MEDIUM = BREAKPOINT_MEDIUM;

export const MARKETING_PAGE_BREAKPOINT_TABLET_VALUE = 768;
export const MARKETING_PAGE_BREAKPOINT_DESKTOP_VALUE = 1024;

export const MARKETING_PAGE_BREAKPOINT_TABLET = `${MARKETING_PAGE_BREAKPOINT_TABLET_VALUE}px`;
export const MARKETING_PAGE_BREAKPOINT_DESKTOP = `${MARKETING_PAGE_BREAKPOINT_DESKTOP_VALUE}px`;

export const SCREEN_SM = '640px';
export const SCREEN_MD = '768px';
export const SCREEN_NAVBAR = '991px';
export const SCREEN_LG = '1024px';
export const SCREEN_XL = '1280px';
export const SCREEN_XXL = '1536px';


export const IMAGE_HEADER_SIZE = '1319px';

export enum Size {
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  XXL = 'XXL',
  NAV = 'NAV',
  IMAGE_HEADER_SIZE = 'IMAGE_HEADER_SIZE',
}

export const MediaQuery: Record<keyof typeof Size, string> = {
  [Size.SM]: `@media (max-width: ${SCREEN_SM})`,
  [Size.MD]: `@media (max-width: ${SCREEN_MD})`,
  [Size.LG]: `@media (max-width: ${SCREEN_LG})`,
  [Size.XL]: `@media (max-width: ${SCREEN_XL})`,
  [Size.XXL]: `@media (max-width: ${SCREEN_XXL})`,
  [Size.NAV]: `@media (max-width: ${SCREEN_NAVBAR})`,
  [Size.IMAGE_HEADER_SIZE]: `@media (max-width: ${IMAGE_HEADER_SIZE})`,
} as const;
